export function EmptyState({ message }: { message: string }) {
  return (
    <div
      role="status"
      className="rounded-card border border-dashed border-border bg-card p-8 text-center text-muted-foreground"
    >
      {message}
    </div>
  );
}
